module.exports = new __parcel__URL__("industrial-lg.622ad581.jpg").toString();